<template>
  <v-container>
    <template v-for="(sch, key) in schema">

      <v-layout v-if="sch.type == 'object'" row wrap>
        <v-flex xs3 class="text-xs-right">{{ sch.title }}</v-flex>
        <v-flex xs9>
          <form-schema-field-collection
            @input="setValue(key, $event)"
            :value="internalValue[key]"
            :schema="sch.properties"
            :required-keys="sch.required"
            :disabled="disabled"
          ></form-schema-field-collection>
        </v-flex>
      </v-layout>

     <v-layout v-else-if="sch.type == 'array'" row wrap>
        <v-flex xs3 class="text-xs-right">{{ sch.title }}</v-flex>
        <v-flex xs9>
          <div v-for="(val, index) in internalValue[key]" class="field-collection-container">

            <form-schema-field-collection
              v-if="sch.items.type == 'object'"
              @input="setValue(key, $event, index)"
              :value="internalValue[key][index]"
              :schema="sch.items"
              :required-keys="sch.required"
              :disabled="disabled"
            ></form-schema-field-collection>

            <form-schema-field
              v-else
              @input="setValue(key, $event, index)"
              :value="internalValue[key][index]"
              :schema="sch.items"
              :required="isRequired(key)"
              :disabled="disabled"
            ></form-schema-field>

            <v-btn @click="deleteItem(key, index)" class="field-collection-delete" flat small color="primary" :disabled="disabled"><v-icon>delete</v-icon> delete</v-btn>

          </div>
          <v-btn @click="addItem(key)" flat small color="primary" :disabled="disabled"><v-icon>add</v-icon> add</v-btn>
        </v-flex>
     </v-layout>

     <form-schema-field
       v-else
       @input="setValue(key, $event)"
       :value="internalValue[key]"
       :required="isRequired(key)"
       :schema="sch"
       :disabled="disabled"
     ></form-schema-field>

    </template>
  </v-container>
</template>

<script>
import FormSchemaField from './FormSchemaField'

export default {
  name: 'form-schema-field-collection',

  components: {
    'form-schema-field': FormSchemaField
  },

  props: ['value', 'schema', 'requiredKeys', 'disabled'],

  data: function () {
    return {
      internalValue: this.initInternalValue()
    }
  },

  watch: {
    value (newValue, oldValue) {
      Object.assign(this.internalValue, newValue)
    },
    schema (newValue, oldValue) {
      this.internalValue = this.initInternalValue()
      this.sync()
    }
  },

  methods: {

    initInternalValue () {
      let v = {}
      for (let [k, sch] of Object.entries(this.schema)) {
        let val = this.value[k]
        if (sch.type == 'object') {
          v[k] = val != null ? val : {}
        } else if (sch.type == 'array') {
          v[k] = val != null ? val : []
        } else {
          v[k] = val != null ? val : sch.default
        }
      }
      return v
    },

    isRequired (key) {
      return this.requiredKeys != null ? this.requiredKeys.indexOf(key) >= 0 : false
    },

    deleteItem (key, index) {
      this.internalValue[key].splice(index, 1)
      this.sync()
    },

    addItem (key) {
      let item = this.schema[key].items.type == 'object' ? {} : null
      this.internalValue[key].push(item)
    },

    setValue (key, val, index) {
      if (index != null) {
        this.$set(this.internalValue[key], index, val)
        // this.internalValue[key][index] = val
      } else {
        this.internalValue[key] = val
      }
      this.sync()
    },

    sync () {
      this.$emit('input', this.internalValue)
    }

  }

}
</script>
